import { Container, Row, Col } from "react-bootstrap";
import "../Styles/TopDeals.css";
import { FaFacebookF, FaInstagram, FaYoutube, FaHeadphones } from "react-icons/fa";


const ShippingPolicy = ({ user }) => (
  <div className="container py-5">
    <div class="elementor-widget-wrap elementor-element-populated">
<div class="elementor-element elementor-element-9834cf4 elementor-widget elementor-widget-heading" data-id="9834cf4" data-element_type="widget" data-widget_type="heading.default">
<div class="elementor-widget-container">
<h2 class="elementor-heading-title elementor-size-default">Shipping Policy</h2>				</div>
</div>
<div class="elementor-element elementor-element-529a3303 elementor-widget elementor-widget-text-editor" data-id="529a3303" data-element_type="widget" data-widget_type="text-editor.default">
<div class="elementor-widget-container">
<p></p>
<p>Nationwide Shipping</p>
<p></p>
<p></p>
<p>We offer to ship across India.</p>
<p></p>
<p></p>
<p>Taxes for Domestic Orders</p>
<p></p>
<p></p>
<p>Product prices displayed are inclusive of all the taxes. We provide free shipping for certain products in India or certain purchase amounts.&nbsp; There are no hidden charges.</p>
<p></p>
<p></p>
<p>Delivery</p>
<p></p>
<p></p>
<p>Not only we maintain quality, but we also carefully handle our products. Therefore, it is at the prime importance for us to most attentively deliver the product in the same form and manner after carefully inspecting the goods before shipment along with secured and multi-layered packaging.<br/>We provide you with maximum estimated delivery time for your order under the detail section on the product page. We assure to process the shipment of the order within 1-3 business days after order confirmation. Our usual shipment takes 3-5 days in metro cities, 5-7 days in other cities across India. However, most orders are delivered before the stipulated time.<br/>Kindly note: If the order gets delayed or not processed immediately due to some unforeseen reasons, we inform with a follow-up call/email. Once shipped, you receive a shipment confirmation email with a tracking number and delivery details. While we try to ensure that the product reaches you within the delivery time communicated, emergencies may delay the delivery. In such cases, contact our support team for the latest update on your shipment if we have already not informed you.</p>
<p></p>
<p></p>
<p>Track Your Order:</p>
<p></p>
<p></p>
<p>The easiest possible way to track your order status is by checking the order details. We try our best to deliver your order as quick as possible. In a few cases where we get delayed, we proactively call/email the customer to inform about the status of their product. In an exceptional case when you have not received any information from us for 10 days after placing an order, you can call us at +919654870373 or email us at support@matihaat.com.</p>
<p></p>								</div>
</div>
</div>
      <footer style={{ backgroundColor: "#f9f9f9", color: "#2b2b2b", padding: "40px 0" }}>
      <Container>
        <Row className="text-center text-md-start">
          {/* Left Column */}
          <Col md={4} className="mb-4 mb-md-0">
            <img
              src="https://matifoods.in/wp-content/uploads/2022/04/Mati-Haat-Web-Logo-2.png"
              alt="Mati Haat"
              style={{ width: "130px", marginBottom: "20px" }}
            />
            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
              <FaHeadphones style={{ color: "#8BC34A", fontSize: "30px", marginRight: "10px" }} />
              <div>
                <p className="mb-0">Got Questions? Call us 24/7!</p>
                <strong>+91 9654870373</strong>
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-center justify-content-md-start gap-3">
              <a href="https://www.facebook.com/profile.php?id=61550736893804" style={{ color: "#000" }} className=" fs-5" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://www.instagram.com/matihaat/" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.youtube.com/@FarmingwithMatihaat" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div>
          </Col>

          {/* Middle Column - Quick Links */}
          <Col md={4} className="mb-4 mb-md-0">
            <h5 style={{ color: "#7BA127" }}>Quick Links</h5>
            <ul className="list-unstyled">
              <ul className="list-unstyled">
                <li><a href="/about-us" style={{ color: "#000" }} className="text-decoration-none">About Us</a></li>
                <li><a href="/contact-us" style={{ color: "#000" }} className="text-decoration-none">Reach Us</a></li>
               
                
                
                <li><a href="/track-order" style={{ color: "#000" }} className="text-decoration-none">Track your Order</a></li>
              </ul>
            </ul>
          </Col>

          {/* Right Column - Customer Care */}
          <Col md={4}>
            <h5 style={{ color: "#7BA127" }}>Customer Care</h5>
            <ul className="list-unstyled">
              <li><a href="/privacy-policy" style={{ color: "#000" }} className="text-decoration-none">Privacy Policy</a></li>
              <li><a href="/shipping-policy" style={{ color: "#000" }} className="text-decoration-none">Shipping Policy</a></li>
              <li><a href="/refund-policy" style={{ color: "#000" }} className="text-decoration-none">Refund and Returns Policy</a></li>
              <li><a href="/payment-methods" style={{ color: "#000" }} className="text-decoration-none">Payment Methods</a></li>
              <li><a href="/terms-and-conditions" style={{ color: "#000" }} className="text-decoration-none">Terms and Conditions</a></li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  </div>

  
);

export default ShippingPolicy;